
.wrapper {
  min-height: 100vh;
  background: linear-gradient(160deg, rgb(1, 42, 92) 0%, rgb(3, 74, 154) 35%, rgb(27, 109, 208) 65%, rgb(46, 138, 230) 100%);
  font-family: 'MuseoSans', sans-serif;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.decorativeCircleTop {
  position: absolute;
  top: -120px;
  right: -80px;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.04) 0%, transparent 70%);
  pointer-events: none;
}

.decorativeCircleBottom {
  position: absolute;
  bottom: -100px;
  left: -60px;
  width: 350px;
  height: 350px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.03) 0%, transparent 70%);
  pointer-events: none;
}

.mainContent {
  flex: 1 1 0%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  position: relative;
  z-index: 1;
}

.formWrapper {
  width: 100%;
  max-width: 400px;
}

.logoContainer {
  text-align: center;
  margin-bottom: 48px;
}

.logo {
  height: 28px;
  opacity: 0.95;
}

.formCard {
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  padding: 40px 32px 36px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: rgba(0, 0, 0, 0.12) 0px 8px 32px;
}

.formHeader {
  margin-bottom: 32px;
}

.title {
  color: rgb(255, 255, 255);
  font-size: 24px;
  font-weight: 600;
  margin: 0px 0px 6px;
  letter-spacing: -0.3px;
}

.subtitle {
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
  margin: 0px;
  font-weight: 400;
}

.fieldGroup {
  margin-bottom: 20px;
}

.fieldGroupPassword {
  margin-bottom: 12px;
}

.label {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  display: block;
  margin-bottom: 6px;
  letter-spacing: 0.2px;
}

.input {
  width: 100%;
  padding: 14px 16px;
  font-size: 15px;
  font-family: 'MuseoSans', sans-serif;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  outline: none;
  box-sizing: border-box;
  transition: 0.25s;
  color: rgb(255, 255, 255);
  background: rgba(255, 255, 255, 0.08);
  letter-spacing: 0.2px;
}

.input::placeholder, .passwordInput::placeholder {
  color: rgb(199,199,199);
}

.input:focus {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.1);
}

.input:hover {
  border-color: rgba(255, 255, 255, 0.3);
}

.passwordContainer {
  position: relative;
}

.passwordInput {
  width: 100%;
  padding: 14px 44px 14px 16px;
  font-size: 15px;
  font-family: 'MuseoSans', sans-serif;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  outline: none;
  box-sizing: border-box;
  transition: 0.25s;
  color: rgb(255, 255, 255);
  background: rgba(255, 255, 255, 0.08);
  letter-spacing: 0.2px;
}

.passwordInput:focus {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.1);
}

.passwordInput:hover {
  border-color: rgba(255, 255, 255, 0.3);
}

.passwordToggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  opacity: 0.5;
  transition: opacity 0.2s;
}

.passwordToggle:hover {
  opacity: 0.8;
}

.forgotPasswordContainer {
  text-align: right;
  margin-bottom: 28px;
}

.forgotPasswordLink {
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.forgotPasswordLink:hover {
  color: rgba(255, 255, 255, 0.7);
}

.submitButton {
  width: 100%;
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 600;
  color: rgb(3, 74, 154);
  background: rgb(255, 255, 255);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'MuseoSans', sans-serif;
  letter-spacing: 0.3px;
  transition: 0.25s;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px;
}

.submitButton:hover {
  transform: translateY(-2px);
  box-shadow: rgba(0, 0, 0, 0.15) 0px 4px 16px;
}

.submitButton:active {
  transform: translateY(0);
}

.supportContainer {
  text-align: center;
  margin-top: 28px;
}

.supportText {
  color: rgba(255, 255, 255, 0.4);
  font-size: 13px;
}

.supportLink {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}

.supportLink:hover {
  color: rgba(255, 255, 255, 0.8);
}

.footer {
  text-align: center;
  padding: 20px 24px 24px;
  position: relative;
  z-index: 1;
}

.footerText {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.3);
  margin: 0px;
  letter-spacing: 0.3px;
}
